<div class="w-full">
    <h1 class="font-bold text-xl mb-4">Finalizar Gestión: {{detalleTarea.nombreTarea}}</h1>
 

    @if(documentosGenerados.length > 0){
        <span>Para finalizar esta gestión por favor seleccione 
            el documento certificado que se generó en el sistema y 
            cargar el PDF final con las firmas correspondientes.
        </span>

        <hr> 
        
        <div class="max-h-40 overflow-y-auto mb-5">
            <mat-radio-group [(ngModel)]="documentoSeleccionado">
                <table mat-table [dataSource]="documentosGenerados" class="w-full table-auto">

                <!-- tipoDocumento Column -->
                <ng-container matColumnDef="tipoDocumento">
                    <td mat-cell *matCellDef="let doc">
                    <mat-radio-button [value]="doc" class="w-full flex items-center gap-2">
                        <div class="flex flex-row">
                            <document-icon 
                                [tipoDocumento]="'PDF'" 
                                [background]="'bg-red-600'">
                            </document-icon>
                            <div class="flex flex-col">
                                <span class="font-medium leading-5 text-nowrap">{{doc.nombre}}</span>
                                <span class="text-sm font-normal">
                                    Generado {{doc.fechaCertificacion | date: 'mediumDate'}}
                                </span>
                            </div>
                        </div>                    
                    </mat-radio-button>
                    </td>
                </ng-container>

                <!-- menu Column (vacía por ahora) -->
                <ng-container matColumnDef="menu">
                    <td mat-cell *matCellDef="let doc">
                        <!-- Estado -->
                        <status-sticker
                            [estado]="doc.estado.descripcion" 
                            [color1]="doc.estado.valor1" 
                            [color2]="'#ffff'">
                        </status-sticker>
                    </td>
                </ng-container>

                <tr mat-row *matRowDef="let row; columns: ['tipoDocumento', 'menu']" class="border-b"></tr>
                </table>  
            </mat-radio-group>   
            
        </div>
        @if(documentoSeleccionado){
            <div
                class="flex flex-col items-center justify-center relative w-full h-20 md:h-28 bg-gray-100 border-2 border-dashed border-gray-300 p-2 rounded-md"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)">
                
                    <div class="font-bold mb-2 hidden md:flex">Seleccione un Archivo o Arrastrelo Aquí</div>
                    <button (click)="uploadImage()" class="w-8/12 md:w-4/12 h-12 border border-gray-300 rounded-md flex items-center justify-center bg-[#f4f4f4] hover:bg-[#e0e0e0]">
                    <mat-icon class="">cloud_upload</mat-icon>
                    <p class="pl-2 text-sm md:text-md">Seleccionar Archivo</p>
                    </button>
            
                    <input
                    type="file"
                    accept=".pdf,
                            application/pdf"
                    (change)="onFileSelected($event)"
                    class="hidden"
                    #fileInput
                    required>
                    
                <p class="text-xs font-semibold mt-2">{{ nombreDocumentoSeleccionado }} </p>
            </div>
        }
    }@else {
        <div *ngIf="documentosGenerados.length === 0" class="p-4 text-center text-gray-500">
            No se encontraron documentos certificados.
            Verifique en la sección de documentos emitidos del bien cultural que 
            existan documentos certificados asociados a la gestión.           
        </div>
    }
    
    <hr>

    <div class="w-full flex justify-end gap-3 mt-3">
        <button mat-button mat-raised-button
        class=""  
        [color]="'secondary'" (click)="this.dialogRef.close(false);">
        Cancelar
        </button>

        <button mat-flat-button 
            [color]="'primary'" 
            (click)="completarGestion()"
            [disabled]="!documentoSeleccionado || !uuidDocumentoOficial">
            Finalizar y enviar
        </button>
    </div>
</div>